module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAAAwCAMAAACMqWyjAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAzUExURUdwTP/xAO1CDekYEMcKGIEcKOUAEt0CFN0EFI8aJPvBA/BgCv3UAvR/CP/sAPimBesuDqX/4Y8AAAAKdFJOUwD////deP/l43pdP9C9AAAAv0lEQVRIx+3X0QrDIAwFUJNs0sVE/f+vnSsDXd+ml7EH86JQOKTeqjTcDlTdQzgiqh6/wSQyDkuqi5j0KZOmNaz0aRVf60xyxQWQ6NKNJJZZTMk+H3O2mc5aeKpEZG3w3pgVnumMjc7KeQwxTa6ZlNNSgQQglJtWMWl6bu9IjsG0QX7Jc3rN7BVctSE+8ck02/55xzp+Z1Rw5xlLwmGo84yr47BKxjDMSxEYFpF3wP9edRvb2MY2trGNfYchfxGfPJpXL8cmNZsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/china.png
// module id = amsV
// module chunks = 34